"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImplementedPanjangam = exports.implementedPanjangams = exports.DEFAULT_PANJANGAM = void 0;
exports.getLongitudeOfMoon = getLongitudeOfMoon;
exports.getMoonSignIndex = getMoonSignIndex;
exports.getLunarMansionIndex = getLunarMansionIndex;
exports.getMoonSign = getMoonSign;
exports.getLunarMansion = getLunarMansion;
exports.getStartingLettersForName = getStartingLettersForName;
const Locales_1 = require("./Locales");
const Utils_1 = require("./Utils");
const Vakya_1 = require("./Vakya");
function getLongitudeOfMoonThirukanitha(date) {
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const hour = date.getHours() + date.getMinutes() / 60;
    const timezoneOffset = date.getTimezoneOffset() / 60;
    const julianDate = (0, Utils_1.toJulianDate)(day, month, year);
    const t = (julianDate -
        /* Year 2000 in Julian */ 2451545 +
        /* Adjust hours for UTC */ (hour + timezoneOffset) / 24 -
        0.5) /
        36525;
    const ayanamsa = (0, Utils_1.calculateAyanamsa)(t);
    // Calculate Moon longitude, latitude, and distance using truncated Chapront algorithm
    // Mean longitude, referred to the mean equinox of the date
    let longitude = 218.3164591 + 481267.88134236 * t;
    // Mean elongation of the moon
    const d = (297.8502042 + 445267.1115168 * t) * Utils_1.d2r;
    // Sun's mean anomaly
    const m = (357.5291092 + 35999.0502909 * t) * Utils_1.d2r;
    // Moon's mean anomaly
    const mm = (134.9634114 + 477198.8676313 * t) * Utils_1.d2r;
    // Moon's argument of latitude
    const f = (93.2720993 + 483202.0175273 * t) * Utils_1.d2r;
    const e = 1 - 0.002516 * t - 0.0000074 * t * t;
    const p = 6.288774 * Math.sin(mm) +
        1.274027 * Math.sin(d * 2 - mm) +
        0.658314 * Math.sin(d * 2) +
        0.213618 * Math.sin(2 * mm) -
        0.185116 * e * Math.sin(m) -
        0.114332 * Math.sin(f * 2) +
        (0.058793 * Math.sin(d * 2 - mm * 2) +
            0.057066 * e * Math.sin(d * 2 - m - mm) +
            0.053322 * Math.sin(d * 2 + mm) +
            0.045758 * e * Math.sin(d * 2 - m) -
            0.040923 * e * Math.sin(m - mm) -
            0.03472 * Math.sin(d) -
            0.030383 * e * Math.sin(m + mm)) +
        (0.015327 * Math.sin(d * 2 - f * 2) -
            0.012528 * Math.sin(mm + f * 2) +
            0.01098 * Math.sin(mm - f * 2) +
            0.010675 * Math.sin(d * 4 - mm) +
            0.010034 * Math.sin(3 * mm)) +
        (0.008548 * Math.sin(d * 4 - mm * 2) -
            0.007888 * e * Math.sin(d * 2 + m - mm) -
            0.006766 * e * Math.sin(d * 2 + m) -
            0.005163 * Math.sin(d - mm) +
            0.004987 * e * Math.sin(d + m) +
            0.004036 * e * Math.sin(d * 2 - m + mm) +
            0.003994 * Math.sin(d * 2 + mm * 2));
    longitude += p;
    // Keep within 360 degrees
    while (longitude < 0.0) {
        longitude += 360.0;
    }
    while (longitude > 360.0) {
        longitude -= 360.0;
    }
    longitude += ayanamsa;
    if (longitude < 0.0)
        longitude += 360.0;
    return longitude;
}
exports.DEFAULT_PANJANGAM = 'thirukanitha';
/**
 * Both the moon sign and the lunar mansion are read off this one longitude, so
 * a method is only ever a different way of computing it. Methods are registered
 * as they are implemented; `getStateFromParams` only accepts the ones listed,
 * so an unimplemented method cannot reach the calculation.
 */
const moonLongitudeByPanjangam = {
    thirukanitha: getLongitudeOfMoonThirukanitha,
    vakkiya: Vakya_1.getLongitudeOfMoonVakkiya,
};
exports.implementedPanjangams = Object.keys(moonLongitudeByPanjangam);
const isImplementedPanjangam = (value) => exports.implementedPanjangams.includes(value);
exports.isImplementedPanjangam = isImplementedPanjangam;
function getLongitudeOfMoon(date, panjangam = exports.DEFAULT_PANJANGAM) {
    const calculate = moonLongitudeByPanjangam[panjangam] || getLongitudeOfMoonThirukanitha;
    return calculate(date);
}
function getMoonSignIndex(date, panjangam) {
    return (0, Utils_1.longitudeToZodiac)(getLongitudeOfMoon(date, panjangam));
}
function getLunarMansionIndex(date, panjangam) {
    return Math.floor((getLongitudeOfMoon(date, panjangam) * 60) / 800.0);
}
function getMoonSign(dateOrIndex, locale) {
    return Locales_1.locales[locale].moonSigns[dateOrIndex instanceof Date
        ? getMoonSignIndex(dateOrIndex)
        : dateOrIndex];
}
function getLunarMansion(dateOrIndex, locale) {
    return Locales_1.locales[locale].lunarMansions[dateOrIndex instanceof Date
        ? getLunarMansionIndex(dateOrIndex)
        : dateOrIndex];
}
function getStartingLettersForName(dateOrIndex, locale) {
    return Locales_1.locales[locale].namingLettersByLunarMansions[dateOrIndex instanceof Date
        ? getLunarMansionIndex(dateOrIndex)
        : dateOrIndex];
}
//# sourceMappingURL=Signs.js.map